<template>
  <b-row>
    <b-col>
      <b-form-group label="Odometer Reading">
        <b-input
          v-model="vehicle.odometerReading"
          size="sm"
          type="number"
          :disabled="form.operations === 'In - Operations' || $hasRole(serviceModule, 'Auto Fleet')" />
      </b-form-group>
      <b-form-group label="Mileage Service Due">
        <b-input
          v-model="vehicle.mileageServiceDue"
          size="sm"
          type="number"
          :disabled="form.operations === 'In - Operations' || $hasRole(serviceModule, 'Auto Fleet')" />
      </b-form-group>
      <b-form-group label="Time Service Due">
        <date-picker
          v-model="form.timeServiceDue"
          :shortcuts="false"
          format="YYYY-MM-DD"
          width="100%"
          :disabled-time="true"
          lang="en"
          :disabled="form.operations === 'In - Operations' || $hasRole(serviceModule, 'Auto Fleet')" />
      </b-form-group>
      <b-form-group label="Time Service Days Left">
        <b-input
          v-model="vehicle.timeServiceDaysLeft"
          size="sm"
          :disabled="['Service Update', 'In - Operations'].includes(form.operations) || $hasRole(serviceModule, 'Auto Fleet')" />
      </b-form-group>
      <b-form-group label="Mileage Service Difference">
        <b-input
          v-model="vehicle.mileageServiceDifference"
          size="sm"
          :disabled="['Service Update', 'In - Operations'].includes(form.operations) || $hasRole(serviceModule, 'Auto Fleet')" />
      </b-form-group>
      <b-form-group label="Operation">
        <b-select v-model="form.operations" :options="operationOptions" size="sm" @change="handleOperationChange"
        :disabled="$hasRole(serviceModule, 'Auto Fleet')" />
      </b-form-group>
    </b-col>
    <b-col>
      <div class="text-center">
        <u>Servicing Interval</u>
      </div>
      <b-form-group label="Mileage Interval">
        <b-select
          v-model="form.mileageIntervalSetting"
          :options="mileageIntervalOptions"
          size="sm"
          :disabled="form.operations === 'In - Operations' || $hasRole(serviceModule, 'Auto Fleet')" />
      </b-form-group>
      <b-form-group label="Time Interval">
        <b-select
          v-model="form.timeIntervalSetting"
          :options="timeIntervalOptions"
          size="sm"
          :disabled="form.operations === 'In - Operations' || $hasRole(serviceModule, 'Auto Fleet')" />
      </b-form-group>
      <b-btn v-if="form.operations === 'Service Update'" size="sm" variant="warning" @click="handleSubmit">Save</b-btn>
    </b-col>
  </b-row>
</template>

<script>
import { Spinner } from '@/components'
import DatePicker from 'vue2-datepicker'
import { toastr } from '@/services'
import moment from 'moment'

export default {
  name: 'ServiceMonitoring',
  props: {
    vehicle: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    DatePicker,
    Spinner
  },
  data () {
    return {
      serviceModule: process.env.VUE_APP_MODE === 'production' ? 'CCPL - VMTS v2' : 'OPS - VMTS REVAMP',
      isFetching: false,
      form: {
        operations: 'In - Operations',
        timeServiceDue: null,
        mileageIntervalSetting: null,
        timeIntervalSetting: null
      },
      operationOptions: [
        { value: 'In - Operations', text: 'In – Operations'},
        { value: 'Service Update', text: 'Service Update'},
        // { value: 'Ops Check', text: 'Ops Check'}
      ],
      mileageIntervalOptions: [
        { value: 10000, text: '10000 KM'},
        { value: 15000, text: '15000 KM'}
      ],
      timeIntervalOptions: [
        { value: 6, text: '6 Months'},
        { value: 12, text: '12 Months'}
      ]
    }
  },
  watch: {
    vehicle: {
      immediate: true,
      handler: function(nv) {
        const tmp = JSON.parse(JSON.stringify(nv))
        this.form.operations = 'In - Operations'
        this.form.timeServiceDue = tmp.timeServiceDue || undefined
        this.form.mileageServiceDue = tmp.mileageServiceDue || undefined
        this.form.timeIntervalSetting = tmp.timeIntervalSetting || undefined
        this.form.mileageIntervalSetting = tmp.mileageIntervalSetting || undefined
      }
    }
  },
  methods: {
    handleSubmit () {
      if (isNaN(this.vehicle.mileageServiceDue) || isNaN(this.vehicle.odometerReading)) {
        return
      }
      const payload = {
        ...this.form,
        timeServiceDue: this.form.timeServiceDue ? moment(this.form.timeServiceDue).format('YYYY-MM-DD') : undefined,
        vehicleNumber: this.vehicle.licensePlate,
        mileageServiceDue: this.vehicle.mileageServiceDue,
        odometerReading: this.vehicle.odometerReading
      }
      this.$store.dispatch('vmts/upsertServiceMonitoring', [payload])
        .then(() => {
          toastr.success(false, 2000)
          this.$emit('submitted')
        }).catch((err) => {
          console.log(err)
          toastr.serverError()
        })
    },
    handleOperationChange (val) {
      // if (val === 'Ops Check') {
      //   this.$router.push({ name: 'FieldChecklist', params: { licensePlate: this.vehicle.licensePlate }})
      // }
    }
  }
}
</script>

<style>

</style>